$(function () {    

    function loadImage(el) {
        //If lazy load image has not already been loaded, load it
        if (elementInViewport(el[0])) {
            if ($(el).attr("data-src")) {
                $(el).attr("src", $(el).attr("data-src"));
                $(el).attr("data-src", null);
            }
        }
    }    

    //Re-used function lifted from other project
    //This checks if any part of the element is in viewport
    function elementInViewport(el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < (window.pageYOffset + window.innerHeight) &&
            left < (window.pageXOffset + window.innerWidth) &&
            (top + height) > window.pageYOffset &&
            (left + width) > window.pageXOffset
        );
    }    

    $(window).on("scroll", function () {
        var lazyLoadedImages = $("img.lazy[data-src]");
        for (var i = 0; i < lazyLoadedImages.length; i++) {
            loadImage(lazyLoadedImages.eq(i));         
        }
    })

    $(window).on("scroll", function () {
        var lazyLoadedIframes = $("iframe[data-src]");
        for (var i = 0; i < lazyLoadedIframes.length; i++) {
            loadImage(lazyLoadedIframes.eq(i));
        }
    })

})